<template lang="pug">
  div
    top-nav(headerColor="white")
    .placeholder(v-if="loading")
    transition(name="fade")
      .content.program(v-if='!loading')
        .grid
          .col-4_xs-12.titles
            router-link(:to="{ name: 'programs'}")
              h2.h-l
                | programs
            router-link(:to="{name: 'programs-overview', params: { category: formatRoute(category) }}")
              h4.category.h-sm
                | {{ category }}
            h1.h-xl
              | {{ title }}
            h4.h-sm
              | {{ date }}
            h4.h-sm
              | {{ startTime }} - {{ endTime }}
            .location
              h4.h-sm
                | {{ locationName }}
              h4.h-sm
                | {{ location }}
              h4.h-sm
                | {{ locationAdd }}
            h4.share.h-sm(@click="share=!share")
              | share
              transition(name='fade')
                social(v-if="share" :meta="shareInfo")
          .col-8_xs-12
            .hero
              img.cover(:src="hero.url" v-if="hero.url" :alt="heroCaptions")
            .captions-hero(v-if="heroCaptions")
              p(v-html="heroCaptions")
            .copy.grid.no-margin(:class="{ noimage: !hero.url }")
              .col-7_xs-12.wysiwyg(v-html="text")
              a.col-3_xs-12(:href="rsvp" target="_blank" v-if="rsvp.length > 0 && rsvpAllowed")
                h4.rsvp.h-sm
                  | rsvp for this event
          .col-4_xs-12.related(v-if="related.length > 0")
            h2.h-l
              | related programs
          .col-8_xs-12.related(v-if="related.length > 0")
            .grid.no-margin
              .col-5_xs-12.details(v-for="program in related" data-push-right="off-1")
                router-link(:to="{name: 'programs-page', params: {category: 'current', id: program.uid }}")
                  h3.h-m
                    | {{ program.title }}
                  h4.h-sm
                    | {{ program.content.date}}
                  p.h-sxx
                    | {{ program.content.start_time }} - {{ program.content.end_time }}
                  .col-4.related
          .col-4_xs-12.related(v-if="relatedExhibitions.length > 0")
            h2.h-l
              | related exhibitions
          .col-8_xs-12.related(v-if="relatedExhibitions.length > 0")
            .grid.no-margin
              .col-5_xs-12.details(v-for="exhibition in relatedExhibitions" data-push-right="off-1")
                router-link(:to="{name: 'exhibition-single', params: {year: year(exhibition), id: exhibition.uid }}")
                  h3.h-m
                    | {{ exhibition.content.title }}
                  h4.h-sm
                    | {{ exhibition.content.teaser }}
                  p.h-sxx
                    | {{ relatedExhibitionDate(exhibition) }}
                  .col-4.related
    bottom-nav(footerColor="white")
</template>

<script>
import DataMixin from '@/mixins/DataMixin'
import ComponentMixin from '@/mixins/ComponentMixin'

export default {
  name: 'programs',
  mixins: [DataMixin, ComponentMixin],

  created () {
    localStorage.clear()
    this.requestData('programs/' + this.$route.params.id, 'program')
    this.key = 'programs/' + this.$route.params.id
  },

  data () {
    return {
      share: false
    }
  },

  methods: {
    relatedExhibitionDate: function (ex) {
      let start = ''

      if (ex.content.start_year !== ex.content.end_year) {
        start = ex.content.start_date + ', ' + ex.content.start_year
      } else {
        start = ex.content.start_date
      }
      const end = ex.content.end_date + ', ' + ex.content.end_year
      return start + ' - ' + end
    },

    year: function (exhibition) {
      return exhibition.content.start_year
    },

    formatRoute: function (item) {
      return item.replace(/ |'/g, '-').toLowerCase()
    }
  },

  computed: {
    content: function () {
      return this.loadedData[this.key].content
    },

    category: function () {
      return this.content.category
    },

    title: function () {
      return this.content.title
    },

    text: function () {
      return this.content.text
    },

    files: function () {
      return this.loadedData[this.key].files
    },

    date: function () {
      return this.content.date
    },

    startTime: function () {
      return this.content.start_time
    },

    endTime: function () {
      return this.content.end_time
    },

    locationName: function () {
      return this.content.location_name
    },

    location: function () {
      return this.content.location
    },

    locationAdd: function () {
      return this.content.location_add
    },

    rsvp: function () {
      return this.content.eventbrite
    },

    rsvpAllowed: function () {
      console.log()
      return this.loadedData[this.key].rsvp_allowed
    },

    related: function () {
      if (this.loadedData[this.key].related) {
        return this.loadedData[this.key].related
      }
      return []
    },

    relatedExhibitions: function () {
      if (this.loadedData[this.key].related_exhibitions) {
        return this.loadedData[this.key].related_exhibitions
      }
      return []
    },

    hero: function () {
      const name = this.content.main_image
      if (name.length > 0) {
        return this.files.find(item => item.filename === name)
      } else {
        return false
      }
    },

    heroMeta: function () {
      if (!(Object.prototype.toString.call(this.hero.meta) === '[object Array]')) {
        return this.hero.meta
      } else {
        return false
      }
    },

    heroCaption: function () {
      if (this.heroMeta) {
        return this.heroMeta.caption.length > 0 ? this.heroMeta.caption : false
      }
    },

    heroCredit: function () {
      if (this.heroMeta) {
        return this.heroMeta.credit.length > 0 ? this.heroMeta.credit : false
      }
    },

    heroCaptions: function () {
      const cap = this.heroCaption
      const cred = this.heroCredit
      if (cap && cred) {
        return cap + '. ' + cred + '.'
      } else if (cap) {
        return cap + '.'
      } else if (cred) {
        return cred + '.'
      } else {
        return false
      }
    },

    shareInfo: function () {
      const data = {
        // url: this.loadedData[this.key].url,
        url: window.location.href,
        title: this.title,
        description: this.text,
        image: this.hero.url
      }
      return data
    }
  },

  watch: {
    $route: function () {
      localStorage.clear()
      this.key = 'programs/' + this.$route.params.id
      this.requestData(this.key, 'program')
      window.scrollTo(0, 0)
    }
  }
}
</script>

<style lang="sass">
  @import '../styles/_mixins'
  @import '../styles/_variables'
  .program
    .captions-hero
      margin-top: 1.2rem
      p
        color: #636466
    .titles
      margin-top: 14rem
      @include respond-to(xs)
        margin-top: 0
      h1, .status, .teaser, .category
        color: $programs
      h1
        padding-top: 1rem
      h4
        margin: 0
      .share
        margin-top: 2rem
        cursor: pointer
        color: #939598
      .category
        padding: 0
      .location
        margin-top: 1rem
    .copy
      margin-top: 4rem
      &.noimage
        margin-top: 14rem
      .rsvp
        width: 80%
        border: solid 2px #000
        margin-left: 15%
        padding: 1rem
        text-align: center
        letter-spacing: unset
        @include respond-to(xs)
          width: calc(100% - 2.25rem)
          margin-left: 0
    .related
      margin-top: 4rem
      h3, h4, a
        padding: 0
        margin: 0
      h3
        padding-top: 0.4rem
        padding-left: 0
      .details
        margin-top: 2px
        a
          &:hover h3
            border-bottom: solid 2px #000
        h3
          display: inline
          border-bottom: solid 2px #FFF
</style>



// WEBPACK FOOTER //
// Program.vue?cdbf1cc2